import { render, staticRenderFns } from "./SidebarCartItem.vue?vue&type=template&id=9ce182d8&"
import script from "./SidebarCartItem.vue?vue&type=script&lang=js&"
export * from "./SidebarCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ce182d8')) {
      api.createRecord('9ce182d8', component.options)
    } else {
      api.reload('9ce182d8', component.options)
    }
    module.hot.accept("./SidebarCartItem.vue?vue&type=template&id=9ce182d8&", function () {
      api.rerender('9ce182d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/SidebarCartItem.vue"
export default component.exports